import React, { createContext, useContext, useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';

const NavigationInterceptorContext = createContext();

export const useNavigationInterceptorContext = () => {
  const context = useContext(NavigationInterceptorContext);
  if (!context) {
    if (typeof window === 'undefined') {
      return {
        registerUnsavedChangesCallback: () => {},
        registerConfirmationCallback: () => {},
        checkUnsavedChanges: () => false,
        showConfirmation: async () => true,
      };
    }
    throw new Error(
      'useNavigationInterceptorContext must be used within a NavigationInterceptorProvider'
    );
  }
  return context;
};

export const NavigationInterceptorProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(() => () => false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(() => () =>
    Promise.resolve(true)
  );

  const registerUnsavedChangesCallback = useCallback(callback => {
    setHasUnsavedChanges(() => callback);
  }, []);

  const registerConfirmationCallback = useCallback(callback => {
    setShowConfirmationDialog(() => callback);
  }, []);

  const checkUnsavedChanges = useCallback(() => {
    return hasUnsavedChanges();
  }, [hasUnsavedChanges]);

  const showConfirmation = useCallback(async () => {
    return await showConfirmationDialog();
  }, [showConfirmationDialog]);

  const value = {
    registerUnsavedChangesCallback,
    registerConfirmationCallback,
    checkUnsavedChanges,
    showConfirmation,
  };

  return (
    <NavigationInterceptorContext.Provider value={value}>
      {children}
    </NavigationInterceptorContext.Provider>
  );
};

NavigationInterceptorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavigationInterceptorProvider;
